export const auditorProfileSchema: any = {
  id: "",
  auditorName: "",
  unit: "",
  systemExpertise: [],
  inLead: [],
  proficiencies: [],
  functionproficiencies: [],
  auditType: [{ item: {} }],
  certifications: [],
  organizationId: "",
};
